import React from 'react';
import { Skeleton } from '@mui/material';
import { useUser } from '../../features/user-management/hooks/useUserWithRole';

interface UserNameDisplayProps {
  userId: string;
  fallback?: string;
  showSkeleton?: boolean;
}

/**
 * Component that displays a user's name by fetching it from their ID
 * Shows a loading skeleton while fetching and fallback text for errors
 */
export const UserNameDisplay: React.FC<UserNameDisplayProps> = ({
  userId,
  fallback = 'Unknown User',
  showSkeleton = true,
}) => {
  const {
    data: user,
    isLoading,
    isError,
  } = useUser(userId, {
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  if (!userId) {
    return <span>{fallback}</span>;
  }

  if (isLoading && showSkeleton) {
    return <Skeleton variant="text" width={80} height={20} />;
  }

  if (isError || !user) {
    return <span>{fallback}</span>;
  }

  return <span>{user.name || user.email || fallback}</span>;
};

export default UserNameDisplay;
